import { useEffect, useState } from 'react';

type OS = 'iOS' | 'Android' | 'unknown';
type Browser =
  | 'Chrome'
  | 'Firefox'
  | 'YaBrowser'
  | 'Safari'
  | 'IE'
  | 'Edge'
  | 'Opera'
  | 'Samsungbrowser'
  | 'unknown';

interface DeviceInfo {
  os: OS;
  browser: Browser;
}

/**
 * Используется для определения браузера/операционной системы по user-agent
 * Реализация не полная и работает только на клиенте, поэтому не рекомендуется для использования
 * В большинстве случаев желательно использовать информацию об устройстве, полученную из useRequest()
 * @deprecated
 */
const useDeviceInfo = (): DeviceInfo => {
  const [deviceInfo, setDeviceInfo] = useState<DeviceInfo>({
    os: 'unknown',
    browser: 'unknown',
  });

  useEffect(() => {
    const userAgent = navigator.userAgent;
    let os: OS = 'unknown';
    let browser: Browser = 'unknown';

    // Определение операционной системы
    if (/android/i.test(userAgent)) {
      os = 'Android';
    } else if (
      (/iPad|iPhone|iPod/i.test(userAgent) && !window.MSStream) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    ) {
      os = 'iOS';
    }

    // Определение браузера
    if (/chrome/i.test(userAgent) && !/edg/i.test(userAgent)) {
      browser = 'Chrome';
    } else if (/firefox/i.test(userAgent)) {
      browser = 'Firefox';
    } else if (/yabrowser/i.test(userAgent)) {
      browser = 'YaBrowser';
    } else if (/safari/i.test(userAgent) && !/chrome/i.test(userAgent)) {
      browser = 'Safari';
    } else if (/msie|trident/i.test(userAgent)) {
      browser = 'IE';
    } else if (/edg/i.test(userAgent)) {
      browser = 'Edge';
    } else if (/opera|opr/i.test(userAgent)) {
      browser = 'Opera';
    } else if (/samsungbrowser/i.test(userAgent)) {
      browser = 'Samsungbrowser';
    }

    setDeviceInfo({ os, browser });
  }, []);

  return deviceInfo;
};

export default useDeviceInfo;
